const state = () => {
  return {
    darkMode: false,
    loading: false
  }
}

// getters
const getters = {
  darkMode: (actualState) => actualState.darkMode,
  loading: (actualState) => actualState.loading
}

// actions
const actions = {
  setDarkMode({ commit }, darkMode) {
    commit('setDarkMode', { darkMode })
  }
}

// mutations
const mutations = {
  setDarkMode(state, { darkMode }) {
    state.darkMode = darkMode
  },
  setShowSpinner(actualState, spinnerShow) {
    actualState.loading = spinnerShow
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
